import { React, useEffect, useState, useRef, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import DropDownPicker from 'react-native-dropdown-picker';

import { getIsAccountOwner } from '../util/storage';
import { getAdminRoles, getDefaultRoles } from '../util/user';
import { useTranslation } from '../i18n';

export default function UpdateRoles({ user, roles, edit, postUpdateAction }) {
  const { t } = useTranslation('admin');

  const [roleOpen, setRoleOpen] = useState(false);
  const [roleValue, setRoleValue] = useState(roles ? roles : []);
  const [roleFilter, setRoleFilter] = useState(getDefaultRoles());
  const [isAccountOwner, setIsAccountOwner] = useState(false);

  // Check if current user is an account owner (can assign admin roles)
  useEffect(() => {
    getIsAccountOwner().then((isOwner) => {
      setIsAccountOwner(isOwner);
      // Update role filter based on account owner status
      if (isOwner) {
        setRoleFilter([...getDefaultRoles(), ...getAdminRoles()]);
      } else {
        setRoleFilter(getDefaultRoles());
      }
    });
  }, []);

  // Track if change is from user action vs prop sync
  const isUserAction = useRef(false);

  // Sync local state with props when user changes
  useEffect(() => {
    setRoleValue(roles ? roles : []);
    isUserAction.current = false;
  }, [user, roles]);

  const setValue = useCallback((value) => {
    if (edit) {
      isUserAction.current = true;
      setRoleValue(value);
    }
  }, [edit]);

  // Notify parent only when user explicitly changes roles
  useEffect(() => {
    if (isUserAction.current && edit && postUpdateAction) {
      isUserAction.current = false;
      postUpdateAction(user, roleValue);
    }
  }, [roleValue, edit, user, postUpdateAction]);

  return (
    <DropDownPicker
      style={{
        minHeight: 28,
        maxHeight: 28,
        marginTop: 5,
        border: 0,
      }}
      textStyle={{
        fontSize: 12,
      }}
      badgeStyle={{
        height: 25,
        width: 100,
        padding: 2,
        disabled: !edit,
        cursor: edit ? 'pointer' : 'default',
      }}
      zIndex={9}
      multiple={true}
      min={0}
      open={roleOpen}
      value={roleValue}
      items={roleFilter}
      setOpen={setRoleOpen}
      setValue={setValue}
      setItems={setRoleFilter}
      placeholder={t('users.noRoleSet')}
      dropDownDirection="TOP"
      disabled={!edit}
      showArrowIcon={edit}
      selectable={edit}
      maxHeight={100}
      extendableBadgeContainer={true}
    />
  );
}
const styles = StyleSheet.create({
  button: {
    cursor: 'pointer',
    marginVertical: 10,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 5,
    width: 95,
    backgroundColor: '#FFC451',
  },
  buttonText: {
    fontSize: 12,
    fontWeight: '600',
  },
});
